module.exports = {
	props: {
		ingredients: {
			type: Array,
			required: true,
			default: function() {
				return []
			}
		},
		unitMultiplier: {
			type: [Number, String],
			default: 1
		},
		unitSelected: {
			type: String,
			
		},
		unitOptions: {
			type: Array,
			default: function() {
				return []
			}
		}
	},
	
	methods: {
		getMultiplierValue(val) {
			let n = val;
			
			if(this.unitSelected === 'volume') {
				return n;
			}
			
			n = n * this.unitMultiplier;
			
			return n.toLocaleString();
		}
	}
}
